import { gql } from '@lcs/shared/api';

export const runCallParking = gql`
   query RunCallParking($params: ExecuteTilePostModelCallParkingTileReportParametersInput!) {
      runCallParkingTile(params: $params) {
         data {
            accountId
            callParkingLots {
               parkerExtension {
                  extensionId
                  accountId
                  name
                  number
               }
               parkerExtensionId
               callerIdInformation
               parkingSlotNumber
               parkDateTime
            }
         }
         dashboardTileId
      }
   }
`;
